import {Competition, CompetitionInformation, IndexCompetition} from "@/types/Competition";
import {httpService} from "@/util/HttpService";
import {CompetitionTest} from "@/types/CompetitionTest";
import {Schedule} from "@/types/Schedule";
import {EqifyOnlineCompetitionSettings} from "@/types/Settings";
import {SearchFilter} from "@/modules/home/filter/service/SearchFilterService";
import {CompetitionPractitionerInfo, ParticipationWithActivity} from "@/types/Participation";

class CompetitionService {
    loadTodayCompetitions(): Promise<Array<IndexCompetition>> {
        return httpService.get("/api/mobile/public/competitions/today")
    }

    searchTodayCompetitions(searchFilter: SearchFilter): Promise<Array<IndexCompetition>> {
        return httpService.post("/api/mobile/public/competitions/today", searchFilter)
    }

    loadThisWeekCompetitions(): Promise<Array<IndexCompetition>> {
        return httpService.get("/api/mobile/public/competitions/this-week-v3")
    }

    searchThisWeekCompetitions(searchFilter: SearchFilter): Promise<Array<IndexCompetition>> {
        return httpService.post("/api/mobile/public/competitions/this-week-v3", searchFilter)
    }

    loadOther(): Promise<CompetitionsOverview> {
        return httpService.get("/api/mobile/public/competitions/other-v3")
    }

    searchOtherCompetitions(searchFilter: SearchFilter): Promise<CompetitionsOverview> {
        return httpService.post("/api/mobile/public/competitions/other-v3", searchFilter)
    }

    loadCompetitionOverview(ref: string): Promise<CompetitionOverview> {
        return httpService.get(`/api/mobile/public/competitions/${ref}/overview`)
    }

    loadCompetition(ref: string): Promise<Competition> {
        return httpService.get(`/api/mobile/public/competitions/${ref}`)
    }

    loadCompetitionInformation(ref: string): Promise<CompetitionInformation> {
        return httpService.get(`/api/mobile/public/competitions/${ref}/information`)
    }

    loadAllLater(): Promise<Array<IndexCompetition>> {
        return httpService.get(`/api/mobile/public/competitions/later/all-v2`)
    }

    loadAllOlder(): Promise<Array<IndexCompetition>> {
        return httpService.get(`/api/mobile/public/competitions/older/all-v2`)
    }

    getRiderInfo(competitionRef: string, riderRef: string): Promise<CompetitionPractitionerInfo> {
        return httpService.get(`/api/mobile/public/competitions/${competitionRef}/rider/${riderRef}`)
    }

    getHorseInfo(competitionRef: string, horseRef: string): Promise<CompetitionPractitionerInfo> {
        return httpService.get(`/api/mobile/public/competitions/${competitionRef}/horse/${horseRef}`)
    }

    search(competitionRef: string, q: string): Promise<Array<ParticipationWithActivity>> {
        return httpService.get(`/api/mobile/public/competitions/${competitionRef}/search?q=${q}`)
    }
}

export interface CompetitionOverview {
    competition: Competition,
    tests: Array<CompetitionTest>,
    schedule?: Schedule,
    settings?: EqifyOnlineCompetitionSettings
}

export interface CompetitionsOverview {
    lastWeek: Array<IndexCompetition>,
    nextWeek: Array<IndexCompetition>,
    later: Array<IndexCompetition>,
    older: Array<IndexCompetition>
}

export const competitionService = new CompetitionService()